import { render, staticRenderFns } from "./PeriodField.vue?vue&type=template&id=1cc0ae32&scoped=true"
import script from "./PeriodField.vue?vue&type=script&lang=ts"
export * from "./PeriodField.vue?vue&type=script&lang=ts"
import style0 from "./PeriodField.vue?vue&type=style&index=0&id=1cc0ae32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc0ae32",
  null
  
)

export default component.exports